import { pgTable, text, unique, uuid, foreignKey, boolean, } from 'drizzle-orm/pg-core';
import { tableBase } from '../../utils';
import { orgId, orgTableBase, orgPrimaryKey } from '../org-id';
import { relations } from 'drizzle-orm';
import { settingsColumns } from '../../settings-columns';
import { Org } from '../org';
export const Team = pgTable('team', {
    ...tableBase,
    name: text('name').notNull(),
    isActive: boolean('is_active').notNull(),
    orgId,
    axleTeamId: text('axle_team_id').notNull(),
    imageUrl: text('image_url'),
}, (table) => ({
    pk: orgPrimaryKey(table),
    uq1: unique().on(table.axleTeamId),
}));
export const Team_Relations = relations(Team, ({ one }) => ({
    settings: one(TeamSettings),
    org: one(Org, {
        fields: [Team.orgId],
        references: [Org.id],
    }),
}));
export const TeamSettings = pgTable('team_settings', {
    ...orgTableBase,
    teamId: uuid('team_id').notNull(),
    ...settingsColumns,
    includeBaseLibraryExercises: boolean('include_base_library_exercises')
        .notNull()
        .default(false),
    warnOnMissingActuals: boolean('warn_on_missing_actuals')
        .notNull()
        .default(false),
}, (table) => ({
    pk: orgPrimaryKey(table),
    teamFk: foreignKey({
        columns: [table.orgId, table.teamId],
        foreignColumns: [Team.orgId, Team.id],
    }),
    uq1: unique().on(table.orgId, table.teamId),
}));
export const TeamSettings_Relations = relations(TeamSettings, ({ one }) => ({
    team: one(Team, {
        fields: [TeamSettings.orgId, TeamSettings.teamId],
        references: [Team.orgId, Team.id],
    }),
}));
//# sourceMappingURL=team.js.map